import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ml-auto" }

import { CardTitle } from '@/components/ui/card';
    import { columns } from '@/tables/columns/salary-status';
    import { computed, ref } from 'vue';
    import { Head } from '@inertiajs/vue3';
    import { usePage } from '@inertiajs/vue3';
    import { useQuery } from '@tanstack/vue-query';
    import { useRoles } from '@/composables/useRoles';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import DataTable from '@/components/datatable/DataTable.vue';
    import MonthPicker from '@/components/MonthPicker.vue';
    import PageCard from '@/components/PageCard.vue';
    import QueryKey from '@/enums/QueryKey';
    import Role from '@/enums/Role';
    import TableTypeSelect from '@/components/datatable/DataTableTypeSelect.vue';
    import type { SharedData, BreadcrumbItem } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Status',
  props: {
    reporting_full_date: {}
  },
  setup(__props: any) {

    const { hasAnyRole } = useRoles();
    const page = usePage<SharedData>();
    const isClient = computed(() => page.props.auth.user.is_client);

    const props = __props;

    const selectedGrouping = ref('my_clients');
    const date = ref(page.props.auth.user.reporting_full_date || props.reporting_full_date);

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'dashboards.payroll',
        },
        {
            title: 'dashboards.employee.payroll_header',
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.SALARY_STATUS, { selectedGrouping, date }],
        queryFn: getSalaryStatuses,
    });

    async function getSalaryStatuses() {
        const { data } = await axios.get(
            route('v2.salary.status.table', {
                reportingPeriod: date.value,
                grouping: selectedGrouping.value,
            }),
        );
        return data.data;
    }

    const typeOptions = [
        { value: 'my_clients', label: 'dashboards.grouping.my_clients' },
        { value: 'all', label: 'dashboards.grouping.all' },
    ];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('dashboards.employee.payroll_header')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, {
      breadcrumbs: breadcrumbs,
      "header-class": "w-full"
    }, _createSlots({
      default: _withCtx(() => [
        _createVNode(PageCard, null, {
          default: _withCtx(() => [
            _createVNode(DataTable, {
              "table-key": _unref(QueryKey).SALARY_STATUS,
              columns: _unref(columns),
              data: _unref(data),
              loading: _unref(isPending),
              "default-sorting": [
                    {
                        id: 'name',
                        desc: false,
                    },
                ]
            }, _createSlots({
              title: _withCtx(() => [
                _createVNode(_unref(CardTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('dashboards.employee.payroll_header')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, [
              (_unref(hasAnyRole)([_unref(Role).SUPER_ADMIN, _unref(Role).PAYROLL]))
                ? {
                    name: "actions",
                    fn: _withCtx(() => [
                      _createVNode(TableTypeSelect, {
                        modelValue: selectedGrouping.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedGrouping).value = $event)),
                        options: typeOptions
                      }, null, 8, ["modelValue"])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["table-key", "columns", "data", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 2
    }, [
      (!isClient.value)
        ? {
            name: "header-actions",
            fn: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                _createVNode(MonthPicker, {
                  modelValue: date.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1024)
  ], 64))
}
}

})